import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { signInWithRedirect, fetchAuthSession } from 'aws-amplify/auth';
import { getUserGroupsOrNull, resolveHome } from '../../shared/utils/auth-groups.util';

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  readonly connecting = signal(false);

  constructor(private router: Router) {}

  async ngOnInit(): Promise<void> {
    // Check if user is already authenticated and redirect accordingly
    await this.checkAuthAndRedirect();
  }

  private async checkAuthAndRedirect(): Promise<void> {
    try {
      const groups = await getUserGroupsOrNull();

      // Pas de session exploitable : on reste sur la page de connexion.
      if (!groups) {
        return;
      }

      // Chaque profil a sa page d'accueil : les Finances pour ADMIN et FINANCE,
      // son espace pour un gestionnaire, /no-access pour le seul rôle de base.
      this.router.navigate([resolveHome(groups)]);
    } catch (error) {
      // User is not authenticated, stay on login page
    }
  }

  // Trigger the Microsoft Entra ID sign-in flow using SAML
  async signInWithMicrosoft(): Promise<void> {
    try {
      // First check if user is already authenticated
      const session = await fetchAuthSession();
      if (session?.tokens?.idToken) {
        // User is already authenticated, just redirect
        await this.checkAuthAndRedirect();
        return;
      }
    } catch (error) {
      // User not authenticated, proceed with sign-in
    }

    // Initiate sign-in flow for unauthenticated users
    this.connecting.set(true);
    try {
      await signInWithRedirect({
        provider: { custom: 'MicrosoftEntraIDSAML' },
      });
    } catch (error) {
      console.error('Sign-in redirect failed:', error);
      this.connecting.set(false);
    }
  }
}
